<template>
    <div class="footer">
        <div class="container">
            <p style="padding-top: 65px;">版权所有：专项能力人才评估中心 rcedu.org.cn</p>
            <!-- <p>地 址：{{webConfigs.address}} 邮编：000000 </p>
            <p>电话：{{webConfigs.mobile}} </p> -->
            <img src="/static/img/erweima.png" v-if="!global.isPhone()"/>
            <span v-if="!global.isPhone()">·手机端·</span>
        </div>
    </div>
</template>
<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    webConfigs: Object,
  },
  data() {
    return {
      webConfig: {},
      global,
    };
  },
  mounted() {},
};
</script>

<style>
.container{
  text-align: left;
}
@media  (max-width:640px) {
  .container{
  text-align: center;
}
}
.footer .container p{
      line-height: 43px;
}
.footer img{
  width: 135px;
    height: 135px;
    float: right;
    top: -128px;
    position: relative;
}
.footer span{
  float: right;
    top: 12px;
    position: relative;
    right: -130px;
    font-size: 18px;
    letter-spacing: 10px;
}
</style>
